/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type PlanSettingsSavedViewsType from '@jira/spa-apps__advanced-roadmaps-plan-settings/src/PlanSettingsSavedViews.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { Props } from '@jira/portfolio-3__portfolio/src/app-simple-plans/view/settings/timeline/types.tsx';

/**
 * Plan Settings - saved-views page
 */

export const LazyPlanSettingsSavedViews: LazyComponent<(props: Props) => React.JSX.Element> =
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof PlanSettingsSavedViewsType>(
		() =>
			markAsProductBundleReady(
				import(
					/* webpackChunkName: "async-plan-settings-saved-views", jiraSpaEntry: "async-plan-settings-saved-views" */ '@jira/spa-apps__advanced-roadmaps-plan-settings/src/PlanSettingsSavedViews.tsx'
				),
			),
		{ ssr: false },
	);

const AsyncPlanSettingsSavedViews = (): React.JSX.Element => (
	<LazyPage
		Page={LazyPlanSettingsSavedViews}
		pageId="plan-settings-saved-views"
		shouldShowSpinner={false}
	/>
);

export default AsyncPlanSettingsSavedViews;
